type InlineSvgProps = {
  asset: {
    url: string;
    description: string;
  };
  width?: number;
  height?: number;
  className?: string;
};

const InlineSvg = (props: InlineSvgProps) => (
  <svg
    data-src={props.asset.url}
    role="img"
    aria-label={props.asset.description}
    {...props}
  />
);

export default InlineSvg;
